import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IResponse } from '../../models/iresponse';
import { BillHeaders } from '../../models/billHeaders';

@Injectable({
  providedIn: 'root'
})
export class OraclepridgeService {

  API_URLGetBillHeaders= `${environment.apiUrl}/OrecalPridge/GetBillHeaders`;
  API_URLGetBillDetails= `${environment.apiUrl}/OrecalPridge/GetBillDetails`;
  API_URLGenerateOracleBills= `${environment.apiUrl}/OrecalPridge/GenerateOracleBills`;
  API_URLGenerateOracleBillsPeriod= `${environment.apiUrl}/OrecalPridge/GenerateOracleBillsPeriod`;
  API_URLSendData= `${environment.apiUrl}/OrecalPridge/SendData`;


  constructor(private http:HttpClient) {
  }

  GetBillHeaders(body:any): Observable<IResponse<BillHeaders>> {
    const url = this.API_URLGetBillHeaders;
    return this.http.post<IResponse<BillHeaders>>(url,body);
  }
  GetBillDetails(id:any): Observable<any> {
    const url = this.API_URLGetBillDetails;
    return this.http.get<any>(`${url}?id=${id}`);
  }
  GenerateOracleBills(date:any): Observable<any> {
    const url = this.API_URLGenerateOracleBills;
    return this.http.get<any>(`${url}?date=${date}`);
  }
  GenerateOracleBillsPeriod(body:any): Observable<any> {
    const url = this.API_URLGenerateOracleBillsPeriod;
    return this.http.post<any>(url,body);
  }
  SendData(body:any): Observable<any> {
    const url = this.API_URLSendData;
    return this.http.post<any>(url,body);
  }
}
